import { useSearchableProjectsForFilteringResourceUsers } from '~/modules/common/hooks/useSearchableProjects';
import { withCriteriaProvider } from './makeCriteriaProvider';

export { default as makeCriteriaProvider } from './makeCriteriaProvider';
export { default as useSearchableProjects } from './useSearchableProjects';

export const makeEnhancedPMCriteriaProvider = (tag, context) =>
  withCriteriaProvider(
    tag,
    context,
    useSearchableProjectsForFilteringResourceUsers
  );
